import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { LOCALE } from 'interfaces/types/Locale'

export const StyledExpertCard = styled.div`
  min-height: 300px;
  height: fit-content;
  &[data-locale='${LOCALE.Taiwan}'] {
    max-height: 270px;
  }
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  gap: 8px;
  text-align: center;
  background-color: #ffffff;
  padding: 12px;
  padding-bottom: 24px;
  border-radius: 8px;
  box-shadow: 0px 24px 32px rgba(0, 0, 0, 0.04),
    0px 16px 24px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);

  .expert-avatar {
    border-radius: 4px;
    height: 140px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    &[data-role='expert'] {
      background: ${theme?.colors.yellow50};
    }
    &[data-role='medical'] {
      background: ${theme?.colors.primary50};
    }
  }
  ${MediaQueries.mbDown} {
    /* height: 120px; */
    min-height: unset;
    direction: ltr;
    flex-direction: row;
    text-align: left;
    gap: 16px;
    box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.04),
      0px 2px 8px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    padding: 12px;
    .expert-avatar {
      width: 100px;
      height: 100px;
      aspect-ratio: 1/1;
    }
  }
`
